/** Fachliche Grundbegriffe, die Browser und Server teilen. */

export const GENDERS = ['female', 'male', 'couple'] as const;
export type Gender = (typeof GENDERS)[number];

/** any = alle; sonst nur, wer das angegeben hat. couple = ein Paar, das andere Paare sucht. */
export const GENDER_FILTERS = ['any', ...GENDERS] as const;
export type GenderFilter = (typeof GENDER_FILTERS)[number];

/** global = weltweit, national = gleiches Land, local = Umkreis in km */
export const SCOPES = ['global', 'national', 'local'] as const;
export type Scope = (typeof SCOPES)[number];

export const RADIUS_KM = { min: 10, max: 300, step: 10, default: 40 } as const;

export const REPORT_REASONS = ['nudity', 'minor', 'harassment', 'spam', 'other'] as const;
export type ReportReason = (typeof REPORT_REASONS)[number];

export interface SearchPrefs {
  scope: Scope;
  radiusKm: number;
  genderFilter: GenderFilter;
}

export const DEFAULT_PREFS: SearchPrefs = {
  scope: 'global',
  radiusKm: RADIUS_KM.default,
  genderFilter: 'any',
};
